import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    logoutLoading: false,
    loading: false,
    loggedIn: false,
    userData: {},
    anonymousUserData: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginStart: (state) => {
            state.loading = true;
        },
        loginSuccess: (state, action) => {
            state.loading = false;
            state.userData = action.payload;
            state.loggedIn = true;
        },
        loginFail: (state) => {
            state.loading = false;
        },
        loginWithGooleStart: (state) => {
            state.loading = true;
        },
        loginWithGoogleSuccess: (state, action) => {
            state.loading = false;
            state.userData = action.payload;
            state.loggedIn = true;
        },
        loginWithGoogleFail: (state) => {
            state.loading = false;
        },
        loginWithAppleStart: (state) => {
            state.loading = true;
        },
        loginWithAppleSuccess: (state, action) => {
            state.loading = false;
            state.userData = action.payload;
            state.loggedIn = true;
        },
        loginWithAppleFail: (state) => {
            state.loading = false;
        },
        logoutStart: (state) => {
            state.loading = true;
        },
        logoutSuccess: (state, action) => {
            state.loading = false;
            state.userData = {};
            state.loggedIn = true;
        },
        logoutFail: (state) => {
            state.loading = false;
        },
        registerStart: (state) => {
            state.loading = true;
        },
        registerSuccess: (state, action) => {
            state.loading = false;
            state.userData = action.payload;
            state.loggedIn = true;
        },
        registerFail: (state) => {
            state.loading = false;
        },
        anonymousUserStart: (state) => {
            state.loading = true;
        },
        anonymousUserSuccess: (state, action) => {
            state.loading = false;
            state.anonymousUserData = action.payload;
            state.loggedIn = true;
        },
        anonymousUserFail: (state) => {
            state.loading = false;
        },
        deleteAccountStart: (state) => {
            state.loading = true;
        },
        deleteAccountSuccess: (state, action) => {
            state.loading = false;
            state.userData = {};
            state.loggedIn = true;
        },
        deleteAccountFail: (state) => {
            state.loading = false;
        },

        verifyEmailStart: (state) => {
            state.loading = true;
        },
        verifyEmailSuccess: (state, action) => {
            state.loading = false;
        },
        verifyEmailFail: (state) => {
            state.loading = false;
        },

        resendCodeStart: (state) => {
            state.loading = true;
        },
        resendCodeSuccess: (state, action) => {
            state.loading = false;
        },
        resendCodeFail: (state) => {
            state.loading = false;
        },


        forgotPasswordStart: (state) => {
            state.loading = true;
        },
        forgotPasswordSuccess: (state, action) => {
            state.loading = false;
        },
        forgotPasswordFail: (state) => {
            state.loading = false;
        },

        resetPasswordStart: (state) => {
            state.loading = true;
        },
        resetPasswordSuccess: (state, action) => {
            state.loading = false;
        },
        resetPasswordFail: (state) => {
            state.loading = false;
        },
    },
});

export const {
    loginStart,
    loginSuccess,
    loginFail,
    logoutStart,
    logoutSuccess,
    logoutFail,
    registerStart,
    registerSuccess,
    registerFail,
    anonymousUserStart,
    anonymousUserSuccess,
    anonymousUserFail,
    loginWithGooleStart,
    loginWithGoogleSuccess,
    loginWithGoogleFail,
    loginWithAppleStart,
    loginWithAppleSuccess,
    loginWithAppleFail,
    deleteAccountStart,
    deleteAccountSuccess,
    deleteAccountFail,
    verifyEmailStart,
    verifyEmailSuccess,
    verifyEmailFail,

    resendCodeStart,
    resendCodeSuccess,
    resendCodeFail,

    forgotPasswordStart,
    forgotPasswordSuccess,
    forgotPasswordFail,

    resetPasswordStart,
    resetPasswordSuccess,
    resetPasswordFail,
} = authSlice.actions;

export default authSlice.reducer;